// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".snackbar-custom.lg .v-snack__content {\n  font-size: 1.5rem !important;\n  font-weight: 500;\n  line-height: 1.8rem;\n  padding: 15px !important;\n}", ""]);
// Exports
module.exports = exports;
